import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M296 64c-13.2 0-24 10.75-24 24v136H48V88c0-13.25-10.75-24-24-24S0 74.75 0 88v336c0 13.3 10.75 24 24 24s24-10.75 24-24V272h224v152c0 13.25 10.75 24 24 24s24-10.7 24-24V88c0-13.25-10.7-24-24-24m256 336h-48V88.02a23.99 23.99 0 0 0-12.69-21.15c-7.81-4.22-17.31-3.75-24.61 1.18l-72 47.1c-11.03 7.344-14 22.25-6.656 33.28 7.375 11.03 22.22 13.97 33.28 6.656L456 132.9V400h-48c-13.25 0-24 10.75-24 24 0 13.3 10.8 24 24 24h143.1c14.1 0 24.9-10.7 24.9-24 0-13.2-10.7-24-24-24",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }